import React, { useState, useEffect } from 'react';
import { signOut, updatePassword } from 'aws-amplify/auth';
import { Button, Modal, Form, Spinner } from 'react-bootstrap';
import { useNavigate, Redirect } from "react-router-dom";
import { getCurrentUser, fetchAuthSession } from "aws-amplify/auth";

import toastr from "toastr";
import config from 'react-global-configuration';

function HeaderComponent({ isLanding = false }) {

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [isGroupGeo, setIsGroupGeo] = useState(false);
    const [isGroupRiskradar, setIsGroupRiskradar] = useState(false);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const navigate = useNavigate();

    const Private = async () => {
        try {
            const { username, userId, signInDetails } = await getCurrentUser();
            const { accessToken, idToken } = (await fetchAuthSession()).tokens ?? {};

            const groups = accessToken.payload['cognito:groups'];
            const isGroupGeo = groups && groups.includes('Customer/Geo');
            const isGroupRiskradar = groups && groups.includes('Customer/Riskradar');
            const isAuthenticated = username || username !== ''


            setIsGroupRiskradar(isGroupRiskradar);
            setIsGroupGeo(isGroupGeo);

            if (!isAuthenticated && !isGroupRiskradar && !isGroupGeo) {
                await signOut();
                localStorage.clear();
                navigate('/');
                window.location.reload();
            }

        } catch (error) {
            await signOut();
            localStorage.clear();
            navigate('/');
            window.location.reload();
        }

    }

    useEffect(() => {
        Private();
        document.body.className = '';
    }, []);

    async function handleSignOut(e) {
        await signOut();
        toastr.warning('Sua sessão foi encerrada e você será redirecionado');
        localStorage.clear();
        setTimeout(() => {
            navigate('/');
            window.location.reload();
        }, 1000);
    }

    async function handleUpdatePassword(e) {
        e.preventDefault();
        setLoading(true);
        try {
            if (newPassword === '' || oldPassword === '' || confirmPassword === '') {
                setLoading(false);
                toastr.warning('Preencha os campos obrigatórios');
                return;
            } else {
                if (confirmPassword.toString() !== newPassword.toString()) {
                    toastr.warning('A confirmação de senha é diferente da senha inserida');
                    return;
                } else {
                    await updatePassword({ oldPassword: oldPassword, newPassword: newPassword });
                    toastr.warning('Senha alterada com sucesso!');
                    setOldPassword('');
                    setNewPassword('');
                    setConfirmPassword('');
                    setShow(false);
                }
                setLoading(false);
            }

        } catch (error) {
            setLoading(false);
            console.log(error);
            if (error.name === 'InvalidPasswordException') {
                toastr.error('A senha não atende aos requisitos da política de senha');
            } else {
                if (error.name === 'NotAuthorizedException') {
                    toastr.error('Ocorreu um erro ao solicitar alteraçõa de senha, senha atual fornecida é incorreta');
                } else {
                    toastr.error('Ocorreu um erro ao solicitar a alteração de senha');
                }
            }
            return;
        }
    }

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
    };
    const handlePasswordChange = (e) => {
        setOldPassword(e.target.value);
    };
    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
    };

    return (
        <>
            <header>
                <a href='/landing'>
                    <img src={process.env.PUBLIC_URL + '/static/imagens/logo.svg'} className='logo' alt='Logomarca' />
                </a>
                <div className='position--relative'>
                    {!isLanding &&
                        <>
                        <a href='javascript:void(0);' className='signout color-secondary bt-user-menu'>{document.location.pathname === '/geo' ? <i className="bi bi-globe2"></i> : <i className="bi bi-journal-text"></i>} <span>{document.location.pathname === '/geo' ? 'GEO' : 'Score'}{isGroupGeo && isGroupRiskradar ? <i className="bi bi-chevron-down" style={{ position: 'relative', top: '2px' }}></i> : ''}</span></a>
                            {isGroupGeo && isGroupRiskradar ?
                                <div className="user-menu-content">
                                    <nav className='user-menu'>
                                        <a href="/geo" className='signout color-secondary mb-3'><i className="bi bi-globe2 float--l"></i>&nbsp;&nbsp;<span>GEO</span> <i className="bi bi-chevron-right"></i></a>
                                        <a href="/score" className='signout color-secondary'><i className="bi bi-journal-text float--l"></i>&nbsp;&nbsp;<span>Score</span> <i className="bi bi-chevron-right"></i></a>
                                    </nav>
                                </div> : <></>
                            }
                            <span className="separador">|</span>
                        </>
                    }
                    <a href='javascript:void(0);' className='bt-user-menu'><i className="bi bi-person-circle user-icon"></i> <i className="bi bi-chevron-down toggle-menu"></i></a>
                    <div className="user-menu-content">
                        <nav className='user-menu'>
                            <a href="#" onClick={handleShow} className='mb-3'><i className="bi bi-key-fill float--l"></i>&nbsp;&nbsp;Alterar Senha <i className="bi bi-chevron-right"></i></a>
                            <a href="#" onClick={handleSignOut} className='mb-3'><span><i className="bi bi-door-open-fill float--l"></i>&nbsp;&nbsp;Sair</span> <i className="bi bi-chevron-right"></i> </a>
                            <hr className='my-1' />
                            <span style={{ fontSize: '0.85rem', padding: '4px 0', display: 'block' }}>
                                <i className="bi bi-info-circle-fill float--l" style={{ fontSize: '18px' }}></i>&nbsp;&nbsp;Sobre
                                <span style={{ display: 'block', paddingLeft: '24px', fontSize: '0.8rem' }}>Version: {config.get('version')}</span>
                            </span>
                        </nav>
                    </div>
                </div>
            </header>
            <Modal show={show} onHide={handleClose} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Alterar Senha</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ width: '80%', margin: '0 auto' }}>
                        <Form>
                            <Form.Group controlId="formPassword" className='group-input--big' style={{ marginTop: "15px" }}>
                                <Form.Label>Senha Atual*:</Form.Label>
                                <Form.Control type="password" value={oldPassword} onChange={handlePasswordChange} className='input--big' />
                            </Form.Group>
                            <Form.Group controlId="formBasicPassword" className='group-input--big' style={{ marginTop: "15px" }}>
                                <Form.Label>Nova Senha*:</Form.Label>
                                <Form.Control type="password" value={newPassword} onChange={handleNewPasswordChange} className='input--big' />
                            </Form.Group>
                            <Form.Group controlId="formBasicConfirmPassword" className='group-input--big' style={{ marginTop: "15px", marginBottom: "15px" }}>
                                <Form.Label>Confirmar Nova Senha*:</Form.Label>
                                <Form.Control type="password" value={confirmPassword} onChange={handleConfirmPasswordChange} className='input--big' />
                            </Form.Group>
                            {loading &&
                                <div className="text-center">
                                    <Spinner animation="border" variant="success" />
                                </div>
                            }
                            <span>
                                <b>A senha deve conter:</b><br />- pelo menos, 6 caracteres e, no máximo, 99 caracteres.<br />- 1 caractere especial dos seguintes: ^ $ * . [ ] { } ( ) ? " ! @ # % & / \ <br />- Letra maiúscula<br />- Letra minúscula
                            </span>
                        </Form>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={(e) => handleClose(e)}>
                        Cancelar
                    </Button>
                    <Button className='small' variant="primary" type='button' onClick={(e) => handleUpdatePassword(e)}>
                        Alterar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default HeaderComponent;